<template>
  <div>
    <div class="code-section">
      <Input placeholder="Supplier Code" :isRequired="true" :inputValue.sync="data.Spp_Code" :isDisabled="data.disabledSuppCode" ref="Spp_Code" />
      <CheckBox title="Active" style="margin-left: 5px" :isChecked.sync="data.Active" :isDisabled="data.viewMode" />
    </div>
    <div class="checkbox-section">
      <CheckBox title="Forwarding Agent" :isChecked.sync="data.IsFwdAgt" :isDisabled="data.viewMode" />
      <CheckBox title="Shipping Agent" :isChecked.sync="data.IsShipAgt" :isDisabled="data.viewMode" />
      <CheckBox title="Shipping Line" :isChecked.sync="data.IsShipLine" :isDisabled="data.viewMode" />
      <CheckBox title="Airline" :isChecked.sync="data.IsAirLine" :isDisabled="data.viewMode" />
      <CheckBox title="Carrier Agent" :isChecked.sync="data.IsCarrierAgt" :isDisabled="data.viewMode" />
      <CheckBox title="East Malaysia Agent" :isChecked.sync="data.IsEastMsiaAgt" :isDisabled="data.viewMode" />
      <CheckBox title="Overseas Agent" :isChecked.sync="data.IsOverseasAgt" :isDisabled="data.viewMode" />
      <CheckBox title="Haulier" :isChecked.sync="data.IsHaulier" :isDisabled="data.viewMode" />
    </div>
    <TabView :tabs="tabs" :viewMode="data.viewMode" :activeTab.sync="data.tabIndex" :loadingPage.sync="loadingTab" :loadingName.sync="loadingName"
      @tabChanged="tabChanged"/>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import CheckBox from '@/components/CheckBox.vue';
import TabView from '@/components/TabView.vue';

export default {
  components: {
    Input, CheckBox, TabView
  },
  props: {
    tabs: { type: Array, default: function() { return [] } },
    data: { type: Object, default: function() { return {} } },

    loadingTab: { type: Boolean, default: false },
    loadingName: { type: String, default: '' },

    focusTo: { type: String, default: '' },
  },
  methods: {
    contactAdded: function(item, edit) {
      this.tabs[1].data.contactItems.forEach((d) => {
        delete d['undefined'];
      });

      var contact = {
        contactaction : item.ID ? 'E' : 'N',
        ID : item.ID ? item.ID : '',
        ContactPerson : item.name,
        TitlePosition : item.position,
        Department : item.department,
        Addr1 : item.addressLine1,
        Addr2 : item.addressLine2,
        Addr3 : item.addressLine3,
        Addr4 : item.addressLine4,
        PostCode : item.postcodeSearch,
        City : item.city,
        State : item.stateSearch,
        Country : item.countrySearch,
        TelNo : item.phone,
        MobileNo : item.mobile,
        FaxNo : item.fax,
        Email : item.email,
        Remarks : item.remarks
      };

      if (edit >= 0) {
        this.tabs[1].data.contactItems.splice(edit, 1, contact);
      } else {
        this.tabs[1].data.contactItems.push(contact);
      }
    },
    contactDeleted: function(contacts) {
      contacts.forEach((c) => {
        var deleteIndex = this.tabs[1].data.contactItems.indexOf(c);
        this.tabs[1].data.contactItems.splice(deleteIndex, 1);

        if (c.ID) {
          this.data.deletedContact.push(c);
        }
      });

      this.tabs[1].data.contactItems.forEach((d) => {
        delete d['undefined'];
      });

    },
    attachmentsAdded: function(items, remarks) {
      for (var i = 0; i < items.length; i++) {
        var reader = new FileReader();
        reader.readAsDataURL(items[i]);
        var current = items[i];

        reader.onload = () => {
          this.tabs[2].data.attachmentItems.push({
            attachmentaction : 'N',
            ID : '',
            FileName : current.name,
            Remarks : remarks,
            Attachment : reader.result
          });
        };
      }
    },
    attachmentsDeleted: function(items) {
      items.forEach((i) => {
        var index = this.tabs[2].data.attachmentItems.indexOf(i);
        this.tabs[2].data.attachmentItems.splice(index, 1);

        if (i.ID) {
          this.data.deletedAttachments.push(i);
        }
      });
    },
    oprCodeAdded: function(opr) {
      this.tabs[4].data.contOperator.push({
        contoperatoraction : 'N',
        ContOperator : opr['ContOperator']
      });
    },
    oprCodeDeleted: function(oprDel) {
      oprDel.forEach((o) => {
        var delIndex = this.tabs[4].data.contOperator.indexOf(o);
        this.tabs[4].data.contOperator.splice(delIndex, 1);

        if (!o.contoperatoraction) {
          this.data.deletedContOperator.push(o);
        }
      })
    },
    pmAdded: function(pm) {
      this.tabs[5].data.vehicleItems.push({
        vehicleaction : 'N',
        Lorry_No : pm['Lorry_No'],
        VehicleCode : pm['Lorry_No'],
        Type : pm['Type']
      });
    },
    pmDeleted: function(pms) {
      pms.forEach((p) => {
        var delIndex = this.tabs[5].data.vehicleItems.indexOf(p);
        this.tabs[5].data.vehicleItems.splice(delIndex, 1);

        if (!p.vehicleaction) {
          this.data.deletedVehicle.push(p);
        }
      });
    },
    tabChanged: function(index) {
      if (!this.focusTo) {
        return;
      }
      switch (index) {
        case 0:
          this.$bus.$emit('supplierGeneralFocusElement', this.focusTo);
          break;
        case 5:
          this.$bus.$emit('supplierAgentFocusElement', this.focusTo);
          break;
        case 4:
          this.$nextTick(() => { 'Hello' });
          this.$bus.$emit('supplierHaulierFocusElement', this.focusTo);
          break;
      }

      this.focusTo = '';
    }
  },
  mounted() {
    this.$bus.$on('contactAdded', this.contactAdded);
    this.$bus.$on('contactDeleted', this.contactDeleted);
    this.$bus.$on('attachmentsAdded', this.attachmentsAdded);
    this.$bus.$on('attachmentsDeleted', this.attachmentsDeleted);
    this.$bus.$on('oprCodeAdded', this.oprCodeAdded);
    this.$bus.$on('oprCodeDeleted', this.oprCodeDeleted);
    this.$bus.$on('pmAdded', this.pmAdded);
    this.$bus.$on('pmDeleted', this.pmDeleted);
  },
  watch: {
    data: {
      deep: true,
      handler: function(val) {
        var agentCheckboxes = val.IsFwdAgt || val.IsShipAgt || val.IsShipLine || val.IsAirLine || val.IsCarrierAgt || val.IsEastMsiaAgt || val.IsOverseasAgt;
        var haulierCheckBox = val.IsHaulier;

        this.tabs[4].enabled = agentCheckboxes == 1;
        this.tabs[5].enabled = haulierCheckBox == 1;
        
        if (val.focusElement) {
          if (val.focusElement == 'Spp_Code') {
            this.$refs[val.focusElement].setFocus();
          } else if (val.focusElement == 'Spp_Name' || val.focusElement == 'Spp_sName') {
            if (val.tabIndex != 0) {
              this.loadingTab = true;
              this.loadingName = 'General Details';
              this.focusTo = val.focusElement;

              setTimeout(() => {
                this.data.tabIndex = 0;
              }, 25);
            } else {
              this.$bus.$emit('supplierGeneralFocusElement', val.focusElement);
            }
          } else if (val.focusElement == 'Ag_DetentionDays' || val.focusElement == 'Ag_FreeStorageDays') {
            if (val.tabIndex != 4) {
              this.loadingTab = true;
              this.loadingName = 'Agent Details';
              this.focusTo = val.focusElement;

              setTimeout(() => {
                this.data.tabIndex = 4;
              }, 25);
            } else {
              this.$bus.$emit('supplierAgentFocusElement', val.focusElement);
            }
          } else if (val.focusElement == 'CMRForm' || val.focusElement == 'DepotTrMode') {
            if (val.tabIndex != 5) {
              this.loadingTab = true;
              this.loadingName = 'Haulier Details';
              this.focusTo = val.focusElement;

              setTimeout(() => {
                this.data.tabIndex = 5;
              }, 25);
            } else {
              this.$bus.$emit('supplierHaulierFocusElement', val.focusElement);
            }
          }

          this.data.focusElement = '';
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.code-section {
  display: flex;
}

.checkbox-section {
  display: flex;
  width: 100%;
  margin-bottom: 10px;

  > * {
    flex-grow: 1;
    margin-right: 5px;
  }
}
</style>